/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {useMultiStyleConfig} from '@chakra-ui/react'
import {Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getCountryName} from '/overrides/app/utils/country-utils'

const AddressDisplay = ({address}) => {
    const style = useMultiStyleConfig('AddressDisplay')

    const countryName = getCountryName(address?.countryCode)

    if (!address) return null

    return (
        <Stack spacing={1} {...style}>
            <Text>
                {address?.firstName} {address?.lastName}
            </Text>
            <Text>
                {address?.address1} {address?.address2} {address?.c_address3}
            </Text>
            <Text>
                {[address?.city, address?.stateCode, address?.postalCode]
                    .filter(Boolean)
                    .join(', ')}
            </Text>
            <Text>{countryName}</Text>
        </Stack>
    )
}

AddressDisplay.propTypes = {
    address: PropTypes.object
}

export default AddressDisplay
